import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as geojson from 'geojson';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LocationType } from './location-type.enum';

@Injectable({
  providedIn: 'root'
})
export class LocationSearchService {

  private static readonly API = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';

  constructor(private http: HttpClient) { }

  search(query: string, types?: LocationType[]) {
    const urlSearch = [
      LocationSearchService.API,
      query,
      '.json?',
      this.tokenParam(),
      this.typeQueryParam(types)
    ];
    return this.http.get(urlSearch.join(''))
      .pipe(
        map((res: geojson.FeatureCollection) => {
          return res.features;
        })
      );
  }

  private typeQueryParam(types: LocationType[]) {
    if (types && types.length) {
      return '&types=' + types.join();
    }
  }

  private tokenParam() {
    return `&access_token=${environment.mapbox.accessToken}`;
  }
}
